import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { PointBaseline, StaffPointReset, StaffPointStrategy, StaffProductLimit } from 'src/app/api/api-campaigns.service.generated';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { StaffPointBaselineComponent } from '../_/staff-point-baseline/staff-point-baseline.component';
import { StaffProductLimitComponent } from '../_/staff-product-limit/staff-product-limit.component';
import { StaffPointResetComponent } from '../_/staff-point-reset/staff-point-reset.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
    selector: 'app-staff-point-strategy',
    templateUrl: './staff-point-strategy.component.html',
    styleUrls: ['./staff-point-strategy.component.scss'],

    imports: [
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatInputModule,
        FlexLayoutModule,
        StaffPointBaselineComponent,
        StaffProductLimitComponent,
        StaffPointResetComponent
    ]
})
export class StaffPointStrategyComponent implements OnInit, OnChanges {

  @Input() strategy: StaffPointStrategy;
  @Input() advertiserId: string;



  form = new FormGroup({
    // staff point strategy
    initialPoints: new FormControl(),
    initialPointsEnabled: new FormControl(),

    productLimitEnabled: new FormControl(),
    productLimit: new FormControl(),

    pointResetEnabled: new FormControl(),
    pointReset: new FormControl(),

    baseline : new FormControl(),

    raffleTicketsEnabled: new FormControl(),
    pointsForRaffleTicket: new FormControl('')
  });

  enabledProductLimit: boolean;
  enabledPointReset: boolean;


  constructor() {
    this.form.get('initialPointsEnabled').valueChanges.subscribe(enabled => {
      this.updateValidator();
      if (!enabled)
        this.form.patchValue({ initialPoints: '0' });
    });

    this.form.get('productLimitEnabled').valueChanges.subscribe(enabled => {
      if (!enabled)
        this.form.patchValue({ productLimit: undefined });
    });

    this.form.get('pointResetEnabled').valueChanges.subscribe(enabled => {
      if (!enabled)
        this.form.patchValue({ pointReset: undefined });
    });

    this.form.get('raffleTicketsEnabled').valueChanges.subscribe(enabled => {
      if (!enabled) {
        this.form.patchValue({ pointsForRaffleTicket: '0' });
        this.form.controls['pointsForRaffleTicket'].clearValidators();
      } else this.form.controls['pointsForRaffleTicket'].setValidators([Validators.required])
    });
  }

  ngOnChanges(): void {
    if (!this.strategy) return;
    this.setFormValue(this.strategy);
  }


  async ngOnInit() {
  }

  setFormValue(model: StaffPointStrategy) {

    this.form.patchValue({
      initialPoints: model.initialPoints.toString(),
      productLimit: model.productLimit,
      pointReset: model.pointReset,
      baseline : model.baseline,
      pointsForRaffleTicket: model.pointsForRaffleTicket?.toString(),
      initialPointsEnabled: model.initialPoints > 0,
      productLimitEnabled: !!model.productLimit,
      pointResetEnabled: !!model.pointReset,
      raffleTicketsEnabled: model.pointsForRaffleTicket > 0
    });
  }

  getFormValue(): StaffPointStrategy {

    if (!this.form.valid) {
      this.forceValidatorsToDisplayErrors();
      return null;
    }
    const f = this.form.value;

    const model = new StaffPointStrategy ({
      ...this.strategy,
      name: 'StaffPointStrategy',

      initialPoints : parseInt(f.initialPoints) > 0 ? parseInt(f.initialPoints) : 0,
      productLimit: this.getProductLimit(f.productLimit),
      pointReset: this.getPointReset(f.pointReset),
      baseline: this.getBaseline(f.baseline),
      pointsForRaffleTicket: parseInt(f.pointsForRaffleTicket)
    });

    return model;
  }

  getProductLimit(productLimit: any) : StaffProductLimit{
    if (!productLimit)
      return undefined;

    var vProductLimit = new StaffProductLimit();
    vProductLimit.init(productLimit);
    return vProductLimit;
  }

  getPointReset(pointReset: any): StaffPointReset{
    if (!pointReset)
      return undefined;

    var vPointReset = new StaffPointReset();
    vPointReset.init(pointReset);
    return vPointReset;
  }

  getBaseline(baseline: any): PointBaseline{
    if (!baseline)
      return  new PointBaseline({
        belowThresholdMultiplier: 1,
        aboveThresholdMultiplier: 1
      });

    var vBaseline = new PointBaseline();
    vBaseline.init(baseline);
    return vBaseline;
  }

  forceValidatorsToDisplayErrors() {
    // force validators to display errors
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key).markAsTouched();
      this.form.get(key).markAsDirty();
    });
  }

  async onSubmit() {
  }

  updateValidator() {
    if (this.form.get('initialPointsEnabled').value) {
      this.form.get('initialPoints').setValidators([Validators.required]);
      this.form.get('initialPoints').updateValueAndValidity();
    } else {
      this.form.get('initialPoints').setValidators([undefined]);
      this.form.get('initialPoints').updateValueAndValidity();
    }
  }

}
